import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDeezer$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDeezer extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ecc256eb4d05dafb83b1769ac5ada1e045c58e73', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4b2a7582f79fc2e005b6338275855af5ad8c4842', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd615e1c8185a4e2c11a871d165c63fd104463b7f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.784 5.65c-.143-.826-.352-1.346-.583-1.347-.433.002-.783 1.803-.783 4.026 0 2.224.35 4.026.783 4.026.177 0 .341-.306.473-.819.208 1.878.64 3.168 1.14 3.168.386 0 .733-.775.967-1.998.159 2.326.56 3.975 1.027 3.975.294 0 .562-.653.76-1.718.239 2.198.79 3.737 1.432 3.737s1.194-1.539 1.431-3.737c.197 1.065.465 1.718.76 1.718.468 0 .868-1.65 1.028-3.975.233 1.223.58 1.998.967 1.998.5 0 .932-1.29 1.14-3.168.13.515.295.82.472.82.433 0 .783-1.803.783-4.027 0-2.223-.35-4.026-.783-4.026-.232 0-.44.521-.583 1.347-.23-1.424-.605-2.35-1.029-2.35-.503 0-.939 1.309-1.145 3.21-.201-1.384-.507-2.266-.85-2.266-.48 0-.889 1.735-1.04 4.154-.285-1.24-.696-2.018-1.152-2.018s-.868.778-1.152 2.018c-.152-2.42-.56-4.154-1.04-4.154-.342 0-.647.882-.85 2.266C7.75 4.609 7.315 3.3 6.813 3.3c-.422 0-.798.926-1.03 2.35M18.7 7.933c0-.994-.199-1.8-.444-1.8s-.444.806-.444 1.8.199 1.8.444 1.8.444-.806.444-1.8m-14.512 0c0-.994-.199-1.8-.444-1.8s-.444.806-.444 1.8.199 1.8.444 1.8.444-.806.444-1.8", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-deezer", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-deezer"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-deezer":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDeezer$1);
            }
            break;
    } });
}

const CosmosIconDeezer = CosmosIconDeezer$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDeezer, defineCustomElement };
